import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { IApiResponse } from '../../../../shared/models/api-response';
import { IVoteDocument } from '../models/vote-document';

export enum BallotUri {
  SR = "srs",
  SD = "sd",
  IEC = "iec",
  CIB = "ci"
}

@Injectable({
  providedIn: 'root'
})
export class BallotDocumentService {

  baseUrl: string = `${environment.servicesUrl.ballot}api/ballots`;

  constructor(
    private http: HttpClient
  ) { }

  DownloadAuthDoc(ballotType: string, voteId: string, ballotId: string): Observable<IApiResponse<IVoteDocument>> {
    return this.http.get<IApiResponse<IVoteDocument>>(`${this.baseUrl}/${ballotType}/${ballotId}/votes/${voteId}/authorisation-documents`);
  }

  DownloadSupportingInformationDocument(ballotType: string, voteId: string, ballotId: string): Observable<IApiResponse<IVoteDocument>> {
    return this.http.get<IApiResponse<IVoteDocument>>(`${this.baseUrl}/${ballotType}/${ballotId}/votes/${voteId}/supporting-information-document`);
  }  
}
